import React from 'react'
import { useState, useEffect } from "react";
import { useWindowSize } from 'react-use';
import { useSessionStorage } from 'react-use'
import { useLocalStorageReducer } from "./useLocalStorageReducer";
import { useSessionStorageReducer } from "./useSessionStorageReducer";
import SearchPanel from './MapSearch/SearchPanel';
import MyMap from './MapSearch/MyMap';
import MyMapLabel from './MapSearch/MyMapLabel';
import MyMapLayerButton from './MapSearch/MyMapLayerButton';
import MyMapLayerDetail from './MapSearch/MyMapLayerDetail';
import MyMapLayerSwitcher from './MapSearch/MyMapLayerSwitcher';
import OptionPanel from './MapSearch/OptionPanel';
import FilterPanelSwitch from './MapSearch/FilterPanelSwitch';

import fitBounds from './MapSearch/MyMapUtils/fitBounds';
import searchItems from './MapSearch/MyMapUtils/searchItems';
import blobPath from './MapSearch/MyMapUtils/blobPath';
import adjustCoordinates from './MapSearch/MyMapUtils/adjustCoordinates';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { useTrackEvent } from "@microsoft/applicationinsights-react-js";

  var reactPlugin = new ReactPlugin();
  var appInsights = new ApplicationInsights({
      config: {
          connectionString: window.SIMPL.appInsightsCONNECTION,
          enableAutoRouteTracking: true,
          extensions: [reactPlugin]
      }
  });
  appInsights.loadAppInsights();
const activeImgMaxHeight = 300;
const pcModeMinWidth = 480;

const viewtype = window.SIMPL.viewType;
//匿名URLページか
const isAnonymousPage = viewtype === "report" || viewtype === "trafficregulation";
const containerStyle = {
    width: "100%",
    height: "calc(100vh - " + (!isAnonymousPage ? 50 : 0 ) + "px)",
};
//検索結果パネルの表示有無
const isShowSearchResultPanel = viewtype !== "jice";
function myMapStyle() {
    return {
        float: 'right',
        width: '100%',
        height:  "calc(100% - " + (!isAnonymousPage ? 50 : 0 ) + "px)",
    };
}
const searchRegionOffset = (isMobileMode, searchPanelVisible) => {
    if (isMobileMode)
        return {
            x: 0,
            y: 140  //キーワード入力欄＋αの高さを除外
        };
    else
        return {
            //検索結果一覧が表示されている、かつ、検索パネルが開いている場合は、検索パネルの幅を除外
            x: isShowSearchResultPanel && searchPanelVisible ? 400 : 0,
            y: 0
        };
}
const _isSettingMapServerType = window.SIMPL.mapServerType !== null && window.SIMPL.mapServerType !== undefined 
    && window.SIMPL.mapServerType !== "" && window.SIMPL.mapServerType !== ''& window.SIMPL.mapServerType !== '*';
const _mapServerType =  window.SIMPL.mapServerType;
const defaultMapServerType = "GoogleMap";

//初期表示の規制期間設定
let nowDate = new Date().toLocaleDateString("ja-JP", {year: "numeric",month: "2-digit",day: "2-digit"}).replaceAll('/', '-');
export default function MapSearch() {

    //操作ログ用
    const [cart, setCart] = useState([]);
    const trackCartUpdate = useTrackEvent(appInsights, "SearchMap", cart);

    const { width, height } = useWindowSize();
    const isMobileMode = width < pcModeMinWidth;
    //モバイルモード、かつ、匿名ページの場合は折り畳み状態を初期表示とする
    const [searchPanelVisible, setSearchPanelVisible] = useState(!(isAnonymousPage && isMobileMode));
    const [streetViewVisible, setStreetViewVisible] = useState(false);

    const userAuthorities = window.SIMPL.userAuthority.split(",");
    const [keyword, updateKeyword] = useSessionStorage("keyword", "");
    const [filters, updateFilter] = useSessionStorageReducer("filters", {
        type: [],                   //対象
        overallHealthLevel: [],     //健全度（性）
        componentManagerOffice: [], //管理事務所
        filmingDateTime_str:"",     //撮影日（開始）
        filmingDateTime_end:"",     //撮影日（終了）

        //福井and鹿島
        primaryCategory: [],        //分類/大分類

        //南砺市
        reportDate_str:"",          //通報日（開始）
        reportDate_end:"",          //通報日（終了）
        reportStatus:[],            //通報状態
        applicationDate_str:"",     //申請日（開始）
        applicationDate_end:"",     //申請日（終了）
        applicationStatus:[],       //規制状態
        restrictedDateTime_str:"",  //規制期間（開始）
        restrictedDateTime_end:"",  //規制期間（終了）

        //JICE
        pavementLength:"pavement100",  //区間表示単位(デフォルトは100m)
        roadBoard:[]        //上下線    

    });
    const [showFilterInfo, updateShowFiltersInfo] = useSessionStorageReducer("showFilterInfo", {
        filterKind: "",
        filterKind_str: "",
        filterKind_end: "",
        popupKind: "",
        masterKind:"",
        isFacilityType: false,
        targetTypes: [],
        DateTime_str:"",
        DateTime_end:"",
        targetType:"",
        label:""
    });
    const [showFilter, setShowFilter] = useState(false);
    const [options, updateOption] = useLocalStorageReducer("options", {
        searchOnIdle: true,
        maxCount: 100,
    });
    const [showOption, setShowOption] = useState(false);

    const [map, setMap] = useState(null);
    const [beforeSearch, setBeforeSearch] = useState(true);
    const [isSearching, setIsSearching] = useState(false);
    const [postSearch, setPostSearch] = useState(false);
    const [items, setItems] = useState([]);
    const [allCount, setAllCount] = useState(0);
    const [overallCount, setOverallCount] = useState(0);
    const [activeItem, setActiveItem] = useState(null);
    const [activeImg, setActiveImg] = useState(null);
    const [error, setError] = useState(null);
    const [activeItemId, setActiveItemId] = useState(null); //マーカークリックでの切替用

    const layerJson = window.SIMPL.layerJson;
    const [mapOptions, updatemapOptions] = useLocalStorageReducer("mapOptions", {
        mapType:"roadmap",                      //表示中の地図種類
        mapStyles:[],                           //表示中の地図種類がJSON定義の場合は対応するStyleが格納される
        isLabel: true,                          //[ラベル]のチェック状態
        isTerrain:false,                        //[地形]のチェック状態
        isLabel_disabled: true,                 //[ラベル]の使用可否
        isTerrain_disabled:false,               //[地形]の使用可否
        layerType:null,                         //表示中のレイヤー種類
        mapServerType:"", //表示中の地図サーバー種類　GoogleMap/GSI
        mapTypeId:"",          //表示中の地図種類
        mapOriginalDataURL:""
    });
    const [showLayerSwitcher, setShowLayerSwitcher] = useState(false);                                                  //レイヤースイッチャの表示状態
    const [mapLayerItems, setMapLayerItems] = useLocalStorageReducer("mapLayerItems", {});                              //各レイヤースイッチャのItems
    const [showLayerDetails, setShowLayerDetails] = useLocalStorageReducer("showLayerDetails", {});                     //各レイヤー詳細の表示状態
    const [mapLayerDetailItems, setMapLayerDetailItems] = useLocalStorageReducer("mapLayerDetailItems", {});            //各レイヤー詳細のItems
    const [markers, setMarkers] = useState([]);
    const [InitialLoadedMap, setInitialLoadedMap] = useState(false);
    
    useEffect(() => {
        updateShowLayerDetails(map);
    }, [showLayerDetails]);

    function updateShowLayerDetails(map){
        if(layerJson === undefined || !Object.keys(layerJson).length){
            return;
        }
        Object.keys(showLayerDetails).forEach(function(key){
            if(map != null){
                if(showLayerDetails[key]){
                    //読込
                    if (mapLayerItems[key] === void 0 || mapLayerItems[key].length === 0) {
                        layerJson.layerGroups.map(layerGroup=>
                            layerGroup.layers.map(layer =>
                                { 
                                    if(layer.id === key && (!layer.authority || layer.authority.startsWith(window.SIMPL.userAuthority) || userAuthorities.some(item => layer.authority.startsWith(item)))){

                                        //geojsonのレイヤー or タイルレイヤー
                                        if(layer.originalDataURL[0].indexOf("geojson") !== -1){

                                            var url =  window.SIMPL.blobUrl + window.SIMPL.layerPath + layer.originalDataURL[0] + window.SIMPL.blobParams;
                                            
                                            map.data.loadGeoJson(url,{}, function (arrf) {
                                                    setMapLayerItems({ type: key, value: arrf});

                                                    //レイヤーの場所に移動
                                                    var bounds = new window.google.maps.LatLngBounds(); 
                                                    arrf.forEach(function(feature){
                                                        feature.getGeometry().forEachLatLng(function(latlng){
                                                        bounds.extend(latlng);
                                                        });
                                                    });
                                                    // map.fitBounds(bounds);
                                            })
                                        }
                                        else{
                                            // タイルレイヤー
                                            //同じID（name）のタイルレイヤーが既に設置されている場合はSKIP
                                            var idx = map.overlayMapTypes.getArray().findIndex(item=>item.name === key);
                                            if(idx === -1){
                                                var ImageMapType = extraMapTypes(layer.originalDataURL[0],layer.id);
                                                map.overlayMapTypes.push(ImageMapType);
                                            }
                                        }
                                    }
                                }
                            )
                        )  
                    }
                    
                    map.data.setStyle(function(feature) {
                            return ({
                                strokeColor: !feature.getProperty('stroke') ? '' : feature.getProperty('stroke'),
                                strokeWeight: !feature.getProperty('stroke-width') ? 0 : feature.getProperty('stroke-width'),
                                fillColor: feature.getProperty('fill'),
                                fillOpacity : 0.5,
                                clickable: false,
                                visible:true,
                                zIndex: 1
                            });
                    });
                }else{
                    //geojsonデータの削除
                    if(mapLayerItems[key]){
                        mapLayerItems[key].forEach(function(one){
                            map.data.remove(one);
                        });
                        setMapLayerItems({ type: key, value: []});
                        setMapLayerDetailItems({ type: key, value:{}});
                    }

                    //タイルレイヤーの解除
                    var idx = map.overlayMapTypes.getArray().findIndex(item=>item.name === key);
                    if(idx !== -1){
                        map.overlayMapTypes.removeAt(idx);
                    }
                    
                }
            }
        });
    }
    function extraMapTypes(url,id){
        const imt = new window.google.maps.ImageMapType({
            getTileUrl: function (coord, zoom) {
              return url.replace("{z}",zoom).replace("{x}",coord.x).replace("{y}",coord.y);
            },
            minZoom: 2,
            maxZoom: 17,
            tileSize: new window.google.maps.Size(256, 256),
            name:id
          });
    
        return imt;
    }

    useEffect(() => {
        if (postSearch) {
            setPostSearch(false);
            search('search');
        }
    }, [postSearch]);

    //初期表示時に検索する処理
    //（※条件：Mapの読み込みが完了していない為、範囲の指定ができない。その為、範囲未設定（retry）の場合と同じ挙動となる）
    function onTilesLoaded(target){
        //JICE以外かつ、最大件数が1000件設定時の最大検索件数の調整（JICEと他環境で行き来した時の調整）
        if(InitialLoadedMap && viewtype !== "jice" && options.maxCount >= 1000){
            updateOption({ type: 'maxCount', value: 200 });
        }

        if (InitialLoadedMap && isAnonymousPage) {
            //初期フィルタの設定（通行規制専用URLの時のみ）
            if(viewtype === "trafficregulation"){
                //画面表示時に規制期間未設定の場合は、当日を設定とする
                if (filters.restrictedDateTime_str.length === 0 || filters.restrictedDateTime_end.length === 0) {
                    onApplyFilter_date("restrictedDateTime_str",nowDate,"restrictedDateTime_end",nowDate);
                }else{
                    setPostSearch(true);
                }
            }
            //初期フィルタの設定（通行規制専用URLの時のみ）
            if(viewtype === "report"){
                //画面表示時にステータス未選択の場合は、市確認中を選択とする
                if (filters.reportStatus.length === 0) {
                    let list = [];
                    list.push("1");
                    // 並べ替え
                    list.sort((a, b) => {
                        if (a > b)
                            return 1;
                        else
                            return -1;
                    });
                    onApplyFilter("reportStatus",list);
                }else{
                    setPostSearch(true);
                }
            }
        }

        if (InitialLoadedMap && viewtype === "jice"){
            setPostSearch(true);
        }
        setInitialLoadedMap(false);
    }

    function onInitMap(map) {
        setMap(map);

        switch(window.SIMPL.mapServerType){
            case "GoogleMap":
                if(mapOptions?.mapTypeId && mapOptions.mapTypeId.startsWith("GoogleMap"))SetMapType(map);
                else ChangeMapServerType(map,window.SIMPL.mapServerType);
            break;

            case "GSI":
                if(mapOptions?.mapTypeId && mapOptions.mapTypeId.startsWith("GSI"))SetMapType(map);
                else ChangeMapServerType(map,window.SIMPL.mapServerType);
            break;

            case "":
            case "*":
                if(mapOptions?.mapTypeId && mapOptions.mapTypeId.startsWith("GoogleMap"))SetMapType(map);
                else if(mapOptions?.mapTypeId && mapOptions.mapTypeId.startsWith("GSI"))SetMapType(map);
                else ChangeMapServerType(map,defaultMapServerType);
            break;
        }

        updateShowLayerDetails(map);  //初期表示用のレイヤー表示

        var thePanorama = map.getStreetView();  //ストリートビュー表示状態変化イベント設定
        window.google.maps.event.addListener(thePanorama, 'visible_changed', function() {
            setStreetViewVisible(thePanorama.getVisible()); //検索パネル、レイヤー、検索件数ラベルの表示状態更新
        });
        
        setInitialLoadedMap(true);
    }

    function SetMapType(map){
        if(mapOptions?.mapStyles?.length != 0){//初期表示用の地図表示
            map.setMapTypeId("roadmap");
            map.setOptions({
                styles:mapOptions.mapStyles
            });
        }else if(mapOptions?.mapOriginalDataURL !== undefined && mapOptions?.mapOriginalDataURL?.length != 0){
            map.setMapTypeId("roadmap");
            map.overlayMapTypes.push(extraMapTypes(mapOptions.mapOriginalDataURL,mapOptions.mapTypeId));
        }
        //ズーム率の固定化
        map.setOptions({
            minZoom:mapOptions.mapTypeId.startsWith("GSI")? 5 : 0,
            maxZoom:mapOptions.mapTypeId.startsWith("GSI")? 18 : 99
        });
    }

    function ChangeMapServerType(map,value){
        updatemapOptions({ type:'mapServerType', value:value});

        //地理院地図レイヤーの解除
        var arr = map.overlayMapTypes.getArray();
        if(arr.length !== 0){
            var deleteArr = map.overlayMapTypes.getArray().map(item =>item.name.startsWith("GSI")? item.name : null);
            deleteArr.forEach((element)=>{
                if(element !== null){
                    var idx = map.overlayMapTypes.getArray().findIndex(item=>item.name === element);
                    map.overlayMapTypes.removeAt(idx);
                }
            })
        }

        //レイヤーが選択されている場合は、一度削除
        var layer = map.overlayMapTypes.getArray().length === 0 ? null : map.overlayMapTypes.getAt(map.overlayMapTypes.getArray().length-1);
        var num = map.overlayMapTypes.getArray().length-1;
        if(layer !== null){
            
            map.overlayMapTypes.removeAt(num)
        }
        

        //各マップグループのデフォルト（1つ目の種類）を表示すること
        if(Object.keys(layerJson).length > 0){
            var arr = layerJson.MapServers.filter(MapServer=>MapServer.MapTypes.length > 0 && MapServer.mapServerType === value);
            
            if(arr.length > 0 && arr[0].MapTypes.length > 0){
                var defaultMapType = arr[0].MapTypes[0][0];
                var originalDataURL = defaultMapType?.originalDataURL?.length > 0 ? defaultMapType?.originalDataURL[0] : undefined;
                onMapTypeCheck(map,defaultMapType.id,defaultMapType.Style,originalDataURL);
            }
        }

        //地図設定後にレイヤーを表示
        //※注意：GoogleMap→地理院地図に地図Groupを切り替えた場合、
        //　　　　地図種類切替時に、選択中のレイヤーが一瞬半透明になってしまう。
        //　　　　この状態で、レイヤーを選択し直すと半透明にならない為、原因は不明。
        if(layer !== null)map.overlayMapTypes.setAt(map.overlayMapTypes.getArray().length,layer);
        
        //左下の「地理院地図」の表示
        let controlText_gsi = document.getElementById("simplLabel_innerHTML_gsi");
        if(controlText_gsi !==null)controlText_gsi.style.display = value.startsWith("GSI")? "" : "none";

        //ズーム率の固定化
        map.setOptions({
            minZoom:value.startsWith("GSI")? 5 : 0,
            maxZoom:value.startsWith("GSI")? 18 : 99
        });
    }

    //地図種類をクリックした時に発生
    function onMapTypeCheck(map,typeDataId,typeDataStyle,typeDataOriginalDataURL)
    {
        //Click前後で地図種類に繁華が無ければ、SKIP
        if(mapOptions.mapTypeId === typeDataId) return;

        //GoogleMapの地図表示
        if(typeDataId.startsWith("GoogleMap")){
            if(typeDataStyle){
                //Styleが設定されている地図種類
                onSetGoogleMapStyleCheck(map,typeDataId,typeDataStyle);
            }else{
                //[デフォルト]か[航空写真]
                onSetGoogleMapCheck(map,typeDataId);
            }
        }

        //地理院地図の地図表示
        if(typeDataId.startsWith("GSI"))
        {
            onSetGSICheck(map,typeDataId,typeDataOriginalDataURL);
        }
    }

    //[デフォルト]か[航空写真]をクリック時に発生
    function onSetGoogleMapCheck(map,typeDataId){

        //「GoggleMap_」を除いた文字列
        var type2 = typeDataId.split('_')[1];

        var mType = "roadmap";
        if("roadmap" === type2){  //地図
            if(mapOptions.isTerrain){
                mType = "terrain";
            }else{
                mType = "roadmap";
            }
            //[ラベル]使用不可、[地形]使用可
            updatemapOptions({ type:'isLabel_disabled', value:true});
            updatemapOptions({ type:'isTerrain_disabled', value:false});
        }else{  //航空写真
            if(mapOptions.isLabel){
                mType = "hybrid";
            }else{
                mType = "satellite";
            }
            //[ラベル]使用可、[地形]使用不可
            updatemapOptions({ type:'isLabel_disabled', value:false});
            updatemapOptions({ type:'isTerrain_disabled', value:true});
        }

        updatemapOptions({type:'mapType',value:mType});
        updatemapOptions({type:'mapTypeId',value:typeDataId});
        updatemapOptions({type:'mapStyles',value:[]});
        updatemapOptions({type:'mapOriginalDataURL',value:""});
        map.setMapTypeId(mType);
        map.setOptions({  //スタイルの解除
            styles:[]
        });
        
    }

    //JSON定義の地図種類をクリックした時に発生
    function onSetGoogleMapStyleCheck(map,typeDataId,typeDataStyle){

        //[ラベル][地形]使用不可
        updatemapOptions({ type:'isLabel_disabled', value:true});
        updatemapOptions({ type:'isTerrain_disabled', value:true});

        //表示中の地図種類、Style格納
        updatemapOptions({type:'mapType',value:typeDataId});
        updatemapOptions({type:'mapTypeId',value:typeDataId});
        updatemapOptions({type:'mapStyles',value:typeDataStyle});

        //航空写真のままだと変化されなかったため、強制的にデフォルトを設定
        map.setMapTypeId("roadmap");
        map.setOptions({
            styles:typeDataStyle
        });

        updatemapOptions({type:'mapOriginalDataURL',value:""});
    }

    function onSetGSICheck(map,typeDataId,typeDataOriginalDataURL){
        
        var idx_new = map.overlayMapTypes.getArray().findIndex(item=>item.name === typeDataId);
        var idx_old = map.overlayMapTypes.getArray().findIndex(item=>item.name === mapOptions.mapTypeId);

        var ImageMapType = extraMapTypes(typeDataOriginalDataURL,typeDataId);

        console.log(map.overlayMapTypes);
        //どっちも未設定
        if(idx_new === -1 && idx_old === -1){
            
            map.overlayMapTypes.insertAt(0,ImageMapType);           
        }
        //1つ前の種類は設定済みの為、その上に表示
        else if(idx_new === -1 && idx_old === 0){
            map.overlayMapTypes.insertAt(1,ImageMapType);
        }
        //新旧どちらも1度設定済みの為、場所の入れ替え
        else if(idx_new === 0 && idx_old === 1){

            var omt = map.overlayMapTypes.getAt(1);
            
            map.overlayMapTypes.setAt(0,omt);
            map.overlayMapTypes.setAt(1,ImageMapType);
        }
        console.log(map.overlayMapTypes);
        

        updatemapOptions({type:'mapType',value:typeDataId});
        updatemapOptions({type:'mapTypeId',value:typeDataId});
        updatemapOptions({type:'mapStyles',value:[]});
        updatemapOptions({type:'mapOriginalDataURL',value:typeDataOriginalDataURL});
        map.setMapTypeId("roadmap");
        map.setOptions({  //スタイルの解除
            styles:[]
        });
    }

    function onIdle() {
        if (options.searchOnIdle && !beforeSearch && !isSearching) {
            search('idleSearch');
        }
    }
    function onSearchClick(){
        search('search');
    }
    function search(mode) {
        const isInRange = mode === 'search' || mode === 'idleSearch';
        setIsSearching(true);

        //操作ログの出力
        if(mode === 'search' || mode === 'initial'){
            trackCartUpdate({ userAccount: window.SIMPL.userAccount,keyword:keyword,type:filters.type,
                overallHealthLevel:filters.overallHealthLevel,componentManagerOffice:filters.componentManagerOffice,primaryCategory:filters.primaryCategory,
                filmingDateTime_str:filters.filmingDateTime_str,filmingDateTime_end:filters.filmingDateTime_end,    //写真
                reportDate_str:filters.reportDate_str,reportDate_end:filters.reportDate_end,reportStatus:filters.reportStatus,  //南砺市：住民通報
                applicationDate_str:filters.applicationDate_str,applicationDate_end:filters.applicationDate_end,applicationStatus:filters.applicationStatus,    //南砺市：通行制限
                restrictedDateTime_str:filters.restrictedDateTime_str,restrictedDateTime_end:filters.restrictedDateTime_end,    //〃
                pavementLength:filters.pavementLength,roadBoard:filters.roadBoard   //JICE
            });
        }
        searchItems(map, isInRange, userAuthorities, keyword, filters, options.maxCount, searchRegionOffset(isMobileMode, searchPanelVisible),viewtype)
            .then(response => response.json())
            .then(
                (result) => {
                    console.log(result);
                    if (result.error)
                        setError(error); //目いっぱいズームアウトすると発生
                    else
                        switchSearch(result, mode);
                },
                (error) => {
                    console.log(error);
                    setError(error);
                }
            )
            .finally(() => {
                setBeforeSearch(false);
                setIsSearching(false);
            });
        setMarkers([]);
    }
    function switchSearch(result, mode) {
        switch (mode) {
            default:
            case 'search':
                if (result.value.length < options.maxCount)
                    search('retry');   // 検索件数を下回る場合、範囲指定なしで検索. これでヒットした場合、地図をパンする。
                else {
                    procOnSearch(result);
                    search('overall');
                }
                break;
            case 'overall':
                setOverallCount(result['@odata.count']);
                break;
            case 'retry':
            case 'initial':
                setOverallCount(result['@odata.count']);
                if (result.value.length === 0)
                    procOnSearch(result);
                else {
                    fitBounds(map, result.value,false,0,0,0,400);
                    if (!options.searchOnIdle)
                        procOnSearch(result);
                }
                break;
            case 'idleSearch':
                procOnSearch(result);
                break;
        }
    }
    function procOnSearch(result) {
        result.value.forEach(item => {
            adjustCoordinates(item);
        });
        //ODataの検索では前方一致以外でもヒットするため、ヒット後にもauthorityをチェックして除外
        setItems(result.value.filter(
            item =>
                userAuthorities.some(auth => item.authority?.startsWith(auth))
            )
        );
        setAllCount(result['@odata.count']);
    }

    function onClearClick() {
        updateKeyword("");
        setBeforeSearch(true);
        setItems([]);
        setMarkers([]);
    }
    function onApplyFilter(filterKind, checkedTypes) {
        updateFilter({ type: filterKind, value: checkedTypes });
        setPostSearch(true);
    }
    function onApplyFilter_date(filterKind_str,date_str,filterKind_end,date_end) {
        updateFilter({ type: filterKind_str, value: date_str });
        updateFilter({ type: filterKind_end, value: date_end });
        setPostSearch(true);
    }
    function onApplyFilter_noSearch(filterKind, checkedTypes) {
        updateFilter({ type: filterKind, value: checkedTypes });
    }
    function onSearch(){
        setPostSearch(true);
    }
    function onChangeMaxCount(val) {
        updateOption({ type: 'maxCount', value: val });
        setPostSearch(true);
    }
    function onEnterImg(e, data_PhotoURL) {
        if (data_PhotoURL) {
            let bounds = e.target.getBoundingClientRect();
            let top = bounds.top + (bounds.bottom - bounds.top) * 0.5 - activeImgMaxHeight * 0.5;
            if (top + activeImgMaxHeight > height) {
                top = height - activeImgMaxHeight;
            }
            setActiveImg({ top: top, left: bounds.left + 16, PhotoURL: data_PhotoURL });
        }
    }
    function onTagClick(val) {
        updateKeyword(val);
        search('search');
    }
    function addMarker(val){
        setMarkers([...markers,{marker:val}]);
    }

    //選択Itemの変更（匿名時のマーカークリック）
    function onChangeActiveItem(itemId){
        //スクロール位置の変更
        document.getElementById(itemId).scrollIntoView(true);
        //色をhover時と同じ色に変化
        document.getElementById(itemId).style.backgroundColor = "#f6f6f6";

        setActiveItemId(itemId);
    }

    //レンダリング後にStatusを参照する
    useEffect(() => {
        if(activeItem !== null && activeItem !== undefined){
            //前のActiveItemの色を戻す（マーカーからクリックしたことを考慮
            document.getElementById(activeItem.id).style.backgroundColor = "";
        }
        
        //対象のItemをリストから取得
        var item = items.find(x=>x.id === activeItemId);

        //ActiveItemの変更
        setActiveItem(item);
      }, [activeItemId])


    function onEnterItem(item){
        if(activeItem !== null && activeItem !== undefined){
            //前のActiveItemの色を戻す（マーカーからクリックしたことを考慮
            document.getElementById(activeItem.id).style.backgroundColor = "";
        }
        
        //ActiveItemの変更
        setActiveItem(item)
    }

    return (
        <div>
            <div className="container-fluid body-content" style={{ padding: 0 }}>
                {showOption && 
                    <OptionPanel
                        maxCount={options.maxCount}
                        searchOnIdle={options.searchOnIdle}
                        width={width}
                        onChangeMaxCount={onChangeMaxCount}
                        onChangeSearchOnIdle={val => updateOption({ type: 'searchOnIdle', value: val })}
                        onBack={() => setShowOption(false)}
                        showHeader={!isAnonymousPage}
                        isMobileMode={isMobileMode}
                        viewtype={viewtype}
                        />}
                {showFilter && 
                    <FilterPanelSwitch
                        width={width}
                        onBack={() => setShowFilter(false)} 
                        
                        userAuthorities={userAuthorities}
                        showFilterInfo={showFilterInfo}
                        keyword={keyword}
                        filters={filters}
                        label={showFilterInfo.label}
                        onApplyFilter={onApplyFilter}
                        onApplyFilter_date={onApplyFilter_date}
                        onApplyFilter_noSearch={onApplyFilter_noSearch}
                        updateShowFiltersInfo={updateShowFiltersInfo}
                        onSearchFilterClick={() => setShowFilter(true)}

                        viewtype={viewtype}
                        showHeader={!isAnonymousPage}
                         />}
                {activeImg &&
                    <img decoding="async" className="sr-item-img-active"
                        style={{ top: activeImg.top, left: activeImg.left }}
                        src={blobPath(activeImg.PhotoURL)}
                        alt="" />}
                <div>
                    {!streetViewVisible &&
                        <div style={{ float: 'left' }}>
                            <SearchPanel
                                searchPanelVisible={searchPanelVisible}
                                isMobileMode={isMobileMode}
                                width={width}
                                height={height}
                                beforeSearch={beforeSearch}
                                isSearching={isSearching}
                                userAuthorities={userAuthorities}
                                keyword={keyword}
                                filters={filters}
                                items={items}
                                onToggleClick={() => setSearchPanelVisible(!searchPanelVisible)}
                                onChangeKeyword={(e) => updateKeyword(e.target.value)}
                                onSearchClick={onSearchClick}
                                onClearClick={onClearClick}
                                onSearch={onSearch}
                                onApplyFilter={onApplyFilter}
                                onApplyFilter_date={onApplyFilter_date}
                                onApplyFilter_noSearch={onApplyFilter_noSearch}
                                onSearchOptionClick={() => setShowOption(true)}
                                onEnterItem={onEnterItem}
                                onLeaveItem={() => setActiveItem(null)}
                                onEnterImg={onEnterImg}
                                onLeaveImg={() => setActiveImg(null)}
                                onTagClick={onTagClick}
                                activeItem={activeItem}
                                map={map}

                                onSearchFilterClick={() => setShowFilter(true)}
                                updateShowFiltersInfo={updateShowFiltersInfo}

                                viewtype={viewtype}
                                showHeader={!isAnonymousPage}
                                isShowSearchResultPanel={isShowSearchResultPanel}
                            />
                            {!isAnonymousPage && !showLayerSwitcher &&
                                <MyMapLayerButton
                                    onLayerButtonClick={() => setShowLayerSwitcher(showLayerSwitcher ? false : true)}
                                    width={width}
                                    searchPanelVisible={searchPanelVisible}
                                    isMobileMode={isMobileMode}
                                    isShowSearchResultPanel={isShowSearchResultPanel}
                                />
                            }
                            {showLayerSwitcher &&
                                <MyMapLayerSwitcher
                                    map={map}
                                    layerJson={layerJson}
                                    mapOptions={mapOptions}
                                    updatemapOptions={updatemapOptions}
                                    onBack={() => setShowLayerSwitcher(false)}
                                    mapLayerItems={mapLayerItems}
                                    setMapLayerItems={setMapLayerItems}
                                    showLayerDetails={showLayerDetails}
                                    setShowLayerDetails={setShowLayerDetails}
                                    userAuthorities={userAuthorities}
                                    mapLayerDetailItems={mapLayerDetailItems}
                                    setMapLayerDetailItems={setMapLayerDetailItems}
                                    width={width}
                                    searchPanelVisible={searchPanelVisible}
                                    isMobileMode={isMobileMode}
                                    isShowSearchResultPanel={isShowSearchResultPanel}

                                    onApplyFilter={onApplyFilter}
                                    extraMapTypes={extraMapTypes}
                                    ChangeMapServerType={ChangeMapServerType}
                                    onMapTypeCheck={onMapTypeCheck}
                                    defaultMapServerType={defaultMapServerType}
                                />}
                            <MyMapLayerDetail
                                showLayerDetails={showLayerDetails}
                                mapLayerDetailItems={mapLayerDetailItems}
                                userAuthorities={userAuthorities}
                                isMobileMode={isMobileMode}
                                searchPanelVisible={searchPanelVisible}
                                isShowSearchResultPanel={isShowSearchResultPanel}
                                width={width}
                            />
                        </div>
                    }
                    <div style={myMapStyle()}>
                        { !streetViewVisible &&
                            <MyMapLabel
                                overallCount={overallCount}
                                allCount={allCount}
                                hitCount={items.length}
                                isMobileMode={isMobileMode}
                                searchPanelVisible={searchPanelVisible}
                                width={width}
                            />
                        }
                        <MyMap
                            items={items}
                            activeItem={activeItem}
                            allCount={allCount}
                            overallCount={overallCount}
                            hitCount={items.length}
                            beforeSearch={beforeSearch}
                            onInitMap={onInitMap}
                            onIdle={onIdle}
                            mapType={mapOptions.mapType}
                            
                            onTagClick={onTagClick}
                            addMarker={addMarker}
                            containerStyle={containerStyle}
                            ControlPosition={"RIGHT_BOTTOM"}
                            showInfoWindow={true}
                            onTilesLoaded={onTilesLoaded}
                            onChangeActiveItem={onChangeActiveItem}
                            mapServerType={_isSettingMapServerType ? _mapServerType : (mapOptions?.mapServerType === undefined ? defaultMapServerType : mapOptions?.mapServerType)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

